import PropTypes from 'prop-types';

import {
  DialogActionsStyled,
  InfoContainerGridStyled
} from '#client/components/Grid/ActionButtonsGrid.style';
import { FocusGrid } from '#client/components/Grid/FocusGrid.style';

import { ButtonWrapper } from './ButtonWrapper';

import { ACTION_BUTTON_TYPE } from './constants';

const ActionInfoButtonsGrid = ({ children, type = ACTION_BUTTON_TYPE.PRIMARY }) => (
  <DialogActionsStyled>
    <InfoContainerGridStyled>
      <FocusGrid>
        <ButtonWrapper type={type}>{children}</ButtonWrapper>
      </FocusGrid>
    </InfoContainerGridStyled>
  </DialogActionsStyled>
);

ActionInfoButtonsGrid.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf([...Object.values(ACTION_BUTTON_TYPE)])
};

export default ActionInfoButtonsGrid;
